import React, { useContext } from 'react';
import { Colors, Text } from 'library';
import { styled } from '@mui/material';

import { BannedWorkerModalContext } from './BannedWorkerModalContext';
import { ShiftProviderUser } from 'models';

export default function Header() {
    const { provider }: { provider: ShiftProviderUser } = useContext(BannedWorkerModalContext);

    return (
        <Container>
            <Text variant="body2" textStyle={{ marginBottom: 15 }}>
                You can block or unblock a worker for your whole center or just specific locations using the options
                below.
                <b> If they&apos;re booked for upcoming shifts, you will need to cancel those shifts individually.</b>
            </Text>
            <Text variant="body2" bold>
                Choose locations to block {provider.first_name} from:
            </Text>
        </Container>
    );
}

const Container = styled('div')({
    paddingBottom: '2em',
});
